import React, { useCallback } from 'react';
import { BiDataHook, BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { useTranslation } from 'react-i18next';
import PrivateIcon from '@wix/da-ds/pkg/Icons/24x24/Private';
import ActionBarIcon from '../../../_partials/ActionBarIcon';
import ActionBarButton from '../../../_partials/items/ActionBarButton';
import ActionBarButtonRestricted from '../../../_partials/ActionBarButtonRestricted';
import { useRestrictToLoggedIn } from '../../../../utils/hooks/useRestrictToLoggedIn';
import { NotificationType } from '../../../../Notifications';
const AddToPrivateCollectionButton = ({ deviation , onClick  })=>{
    const { t  } = useTranslation();
    const { restrictToLoggedIn  } = useRestrictToLoggedIn();
    const clickHandler = useCallback(()=>{
        onClick(deviation);
    }, [
        onClick,
        deviation
    ]);
    const tooltip = t('comment.action.addToPrivate.tooltip');
    return /*#__PURE__*/ React.createElement(ActionBarButtonRestricted, {
        deviation: deviation,
        tooltip: tooltip,
        notificationTypes: [
            NotificationType.CollectPrivate
        ],
        button: /*#__PURE__*/ React.createElement(ActionBarButton, {
            onClick: restrictToLoggedIn(ReferralType.AWARD_BADGE, clickHandler),
            "data-hook": BiDataHook.DEVIATION_AWARD_BADGE_BUTTON,
            "aria-label": tooltip,
            biData: {
                evid: BiEventType.GIVE_BADGE_AWARD,
                sectionname: 'deviation',
                typeid: getDeviationResourceType(deviation),
                itemid: deviation.deviationId
            }
        }, /*#__PURE__*/ React.createElement(ActionBarIcon, {
            icon: PrivateIcon
        }))
    });
};
AddToPrivateCollectionButton.displayName = 'AddToPrivateCollectionButton';
export default AddToPrivateCollectionButton;
